import { PrimeIcons } from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';
import { classNames } from 'primereact/utils';
import React from 'react';

type IconTooltipProps = {
    children: React.ReactNode;
    warning?: boolean;
};

export const IconTooltip = ({ children, warning }: IconTooltipProps) => {
    const refIcon = React.useRef<HTMLElement>(null);

    const icon = warning ? PrimeIcons.EXCLAMATION_TRIANGLE : PrimeIcons.INFO_CIRCLE;

    return (
        <>
            <i
                className={classNames(`icon-tooltip ${icon}`, {
                    'icon-tooltip--warning': warning
                })}
                ref={refIcon}
            />
            <Tooltip target={refIcon as unknown as HTMLElement}>{children}</Tooltip>
        </>
    );
};
